
export default {
  methods: {
    verifyErrorsForm (fields) {
      return new Promise((resolve, reject) => {
        for (const field of fields) {
          field.$touch()
        }
        fields.filter(field => field.$error === true).length === 0 ? resolve() : reject(new Error())
      })
    }

  }
}
